export default () => ({
  errors: {},
  loading: true,
  onCancel: false,
  fullPage: true,
  statistics: []
})



// WEBPACK FOOTER //
// ./src/app/tenant/dashboard/gadget/resources/data.js